const initEventsListSwiper = () => {
	var eventsListSwipers = [].slice.call(document.querySelectorAll(".js-events-list-swiper"));

	if (eventsListSwipers.length) {
		eventsListSwipers.forEach(function (eventsListSwiper) {
			let config = {
                slidesPerView: 1,
                spaceBetween : 10,
				speed: 750,
                pagination: {
					el: "#" + eventsListSwiper.getAttribute("id") + " .swiper-pagination",
                    dynamicBullets: true,
                    clickable: true,
				},
                breakpoints : {
                    576 : {
                        slidesPerView: 2,
                        spaceBetween : 10,
                    },
                    992 : {
                        slidesPerView: 3,
                        spaceBetween : 16,
                    },
                    1330 : {
                        slidesPerView: 4,
                        spaceBetween : 24,
                    },
                }
			};

			let swiperInst = new Swiper(
				"#" + eventsListSwiper.getAttribute("id"),
				config
			);
		});
	}
};

document.addEventListener("DOMContentLoaded", () => {
	initEventsListSwiper();
});

window.addEventListener("force_init_from_backoffice", () => {
	initEventsListSwiper();
});
